<template>
  <el-main class="layout-process-design">
    <div class="scale">
      <el-button icon="el-icon-plus" size="small" @click="scale += 10" :disabled="scale >= 150" circle></el-button>
      <span class="scale-text">{{ scale }}%</span>
      <el-button icon="el-icon-minus" size="small" @click="scale -= 10" :disabled="scale <= 40" circle></el-button>
<!--      <el-button @click="validate">校验流程</el-button>-->
    </div>
    <div class="design" :style="'transform: scale('+ scale / 100 +');'">
      <process-tree ref="process-tree" :isProcess="isProcess" @selectedNode="nodeSelected"/>
    </div>
    <el-drawer :title="selectedNode.name" :visible.sync="showConfig"
               :modal-append-to-body="false"
               :size="selectedNode.type === 'CONDITION' ? '600px':'500px'"
               direction="rtl" :modal="false" destroy-on-close
               class="drawer-node-config">
      <div slot="title">
        <el-input v-model="selectedNode.name" size="medium" v-show="showInput"
                  style="width: 300px" @blur="showInput = false"></el-input>
        <el-link v-show="!showInput" @click="showInput = true" style="font-size: medium">
          <i class="el-icon-edit" style="margin-right: 10px"></i>
          {{selectedNode.name}}
        </el-link>
      </div>
      <div class="node-config-content">
        <node-config  :isProcess="isProcess"/>
      </div>
    </el-drawer>
  </el-main>
</template>

<script>
import ProcessTree from '@/pages/officeApproval/components/process/ProcessTree.vue'
import NodeConfig from '@/pages/officeApproval/common/process/config/NodeConfig'

export default {
  name: "ProcessDesign",
  components: {ProcessTree, NodeConfig},
  props: {
    isProcess: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      scale: 100,
      selected: {},
      showInput: false,
      showConfig: false
    }
  },
  computed:{
    selectedNode(){
      return this.$store.state.selectedNode
    }
  },
  mounted() {
    this.$nextTick(() => {
     console.log('默认>>',)
    })
  },
  methods: {
    validate(){
      return this.$refs["process-tree"].validateProcess()
    },
    nodeSelected(node){
      console.log('配置节点', node)
      this.showConfig = true
    }
  },
  watch:{
    /*selectedNode:{
      deep: true,
      handler(node){
        console.log("更新")
        this.$refs["process-tree"].nodeDomUpdate(node)
      }
    }*/
  }
}
</script>

<style lang="scss" scoped>
.layout-process-design {
  padding: 0;
  height: calc(100vh - 274px);
  background-color: #F8FAFA;
  margin-right: 16px;
}
.design {
  margin-top: 60px;
  display: flex;
  transform-origin: 50% 0px 0px;
}

.scale {
  z-index: 999;
  position: fixed;
  top: 198px;
  right: 66px;
  .scale-text {
    margin: 0 10px;
    font-size: 15px;
    color: #7a7a7a;
    min-width: 50px;
    display: inline-block;
    text-align: center;
  }
  /deep/{
    .el-button:focus, .el-button:hover{
      color: #00B498;
      border-color: rgb(179, 233, 224);
      background-color: rgb(230, 248, 245);
    }
  }
}

.node-config-content{
  padding: 0 20px 20px;
}

/deep/ .el-drawer__body{
  overflow-y: auto;
}
</style>
